import { useCallback, useEffect, useState } from 'react'
import DoughnutGraphPrice from './DoughnutGraphPrice'
import DoughnutGraphTotal from './DoughnutGraphTotal'
import { useTranslation } from 'react-i18next';
import PieGraph from './PieGraph';
import { classCharDoughnutContainerHeight, TAB_0_GRAPH_1_ID, TAB_0_GRAPH_2_ID, TAB_1_GRAPH_1_ID, TAB_1_GRAPH_2_ID, TAB_2_GRAPH_1_ID, TAB_2_GRAPH_2_ID } from '../common';
import { isIterableArray, toFormatPrice } from '../../../utils/utils';
import { Typography } from '@material-tailwind/react';
import { doughnutColors, pieColors } from '../../../utils/variables';

const TabController = ({
    currentData,
    period1,
    period2,
    isMobile,
    selectedTab,
    setSelectedTab,
    tabs
}: any) => {


    const { t } = useTranslation()


    const uniqueCons = Object.keys(currentData.period1.consumption).map(i => {
        return ({
            key: i,
            show: true,
        })
    })

    const keysSet: any = new Set([...Object.keys(currentData.period1.originData), ...Object.keys(currentData.period2.originData)])
    const keysArray: any = Array.from(keysSet)
    const uniquePrice = keysArray.map((i: any) => {
        return ({
            key: i,
            show: true,
        })
    })
    const [legendCons, setLegendCons] = useState(uniqueCons);
    const [legendPrice, setLegendPrice] = useState(uniquePrice);
    const [legendTotal, setLegendTotal] = useState(uniquePrice);


    const formattedCons = useCallback(
        () => {
            if (currentData.period1.consumption) {
                return isIterableArray(Object.keys(currentData.period1.consumption)) ?
                    Object.keys(currentData.period1.consumption).reduce((acc: any, key: any) => {

                        const isshow = legendCons.find(i => i.key === key)

                        if (!isshow?.show) {
                            acc.period1 = { ...acc.period1, [key]: '' }
                            acc.period2 = { ...acc.period2, [key]: '' }
                            return acc
                        }

                        const item1 = currentData.period1.consumption[key]
                        if (item1) {
                            acc.period1 = { ...acc.period1, [key]: item1 }
                        }
                        const item2 = currentData.period2.consumption[key]
                        if (item2) {
                            acc.period2 = { ...acc.period2, [key]: item2 }
                        }
                        return acc
                    }, {
                        period1: {},
                        period2: {},
                    })
                    :
                    false
            }
        },
        [currentData, legendCons]
    )

    const formattedValue = useCallback(
        (valueKey: any, legend: any) => {
            if (currentData.period1.originData) {
                return isIterableArray(keysArray) ?
                    keysArray.reduce((acc: any, key: any) => {
                        const isshow = legend.find((i: any) => i.key === key)
                        if (!isshow?.show) return acc

                        const item1 = currentData.period1.originData[key]
                        if (item1?.[valueKey]) {
                            acc.values1.push(item1[valueKey])
                            acc.labels1.push(key)
                            acc.colors1.push(doughnutColors[key])
                        }
                        const item2 = currentData.period2.originData[key]
                        if (item2?.[valueKey]) {
                            acc.values2.push(item2[valueKey])
                            acc.labels2.push(key)
                            acc.colors2.push(doughnutColors[key])
                        }
                        return acc
                    }, {
                        values1: [],
                        labels1: [],
                        values2: [],
                        labels2: [],
                        colors1: [],
                        colors2: [],
                    })
                    :
                    false
            }
        },
        [currentData, legendPrice, keysArray]
    )

    const formattedConsVal = formattedCons()
    const formattedPriceVal = formattedValue('price', legendPrice)
    const formattedTotalVal = formattedValue('total_for_act', legendTotal)


    // text: '▲ ▼ -6,55%',
    const getCalculateResult = (val1: any, val2: any, compare?: boolean) => {
        if (!!val1 && !!val2) {
            const res = val2 === 0 ? 100 : (((val1 * 100) / val2) - 100)
            return res === 0 ? `${toFormatPrice(res)}%` : `${compare ? '▲' : '▼'} ${compare ? '' : '-'}${toFormatPrice(Math.abs(res))}%`
        }
        return ''
    }
    const getCalculateResultByArr = (arr1: any, arr2: any, compareFunction: any) => {

        const val1 = isIterableArray(arr1) ? arr1?.reduce(
            (acc: any, item: any) => {
                acc = acc + item
                return acc
            }, 0
        ) : 0;

        const val2 = isIterableArray(arr2) ? arr2?.reduce(
            (acc: any, item: any) => {
                acc = acc + item
                return acc
            }, 0
        ) : 0;

        const compare = compareFunction ? compareFunction(val1, val2) : false

        return getCalculateResult(val1, val2, compare)
    }

    return (
        <>
            <div className='flex flex-col lap:flex-row justify-center items-center gap-[24px] lap:gap-[32px] des:gap-[75px]'>
                <div className={classCharDoughnutContainerHeight}>
                    {
                        selectedTab === tabs[0] &&
                        <PieGraph
                            graphId={TAB_0_GRAPH_1_ID}
                            isMobile={isMobile}
                            currentData={{
                                values: formattedConsVal?.period1,
                                compareValues1: currentData?.period1[selectedTab].delta_cons,
                                compareValues2: currentData?.period2[selectedTab].delta_cons,
                            }}
                            originData={currentData?.period1[selectedTab]}
                            isEmpty={currentData?.period1[selectedTab].declared === 0 && currentData?.period1[selectedTab].fact === 0}
                            getCalculateResult={getCalculateResult}
                            compareFunction={(a: any, b: any) => (a > b)}
                        />
                    }
                    {
                        selectedTab === tabs[1] &&
                        <DoughnutGraphPrice
                            graphId={TAB_1_GRAPH_1_ID}
                            isMobile={isMobile}
                            period={period1}
                            currentData={{
                                values: formattedPriceVal?.values1,
                                compareValues1: formattedPriceVal?.values1,
                                compareValues2: formattedPriceVal?.values2,
                                labels: formattedPriceVal?.labels1,
                                colors: formattedPriceVal.colors1
                            }}
                            isEmpty={currentData?.period1[selectedTab].values.length === 0}
                            getCalculateResultByArr={getCalculateResultByArr}
                            compareFunction={(a: any, b: any) => (a > b)}
                        />
                    }
                    {

                        selectedTab === tabs[2] &&
                        <DoughnutGraphTotal
                            graphId={TAB_2_GRAPH_1_ID}
                            isMobile={isMobile}
                            period={period1}
                            currentData={{
                                values: formattedTotalVal?.values1,
                                compareValues1: formattedTotalVal?.values1,
                                compareValues2: formattedTotalVal?.values2,
                                labels: formattedTotalVal?.labels1,
                                colors: formattedTotalVal?.colors1
                            }}
                            isEmpty={currentData?.period1[selectedTab].values.length === 0}
                            getCalculateResultByArr={getCalculateResultByArr}
                            compareFunction={(a: any, b: any) => (a > b)}
                        />
                    }
                </div>
                <div className="flex flex-col mob:flex-row lap:flex-col items-center gap-[8px]">
                    {
                        tabs.map((tabName: any) => (
                            <div
                                key={tabName}
                                onClick={() => setSelectedTab(tabName)}
                                className={`px-[16px] py-[8px] text-[14px] font-medium rounded-full text-center
                                            ${tabName === selectedTab ? 'text-white bg-gray-700' : 'text-gray-700 bg-white cursor-pointer hover:bg-gray-200 transition-all'}    
                                            `}
                            >
                                {t(`analytics.${tabName}`)}
                            </div>
                        ))
                    }
                </div>
                <div className={classCharDoughnutContainerHeight}>
                    {
                        selectedTab === tabs[0] &&
                        <PieGraph
                            graphId={TAB_0_GRAPH_2_ID}
                            isMobile={isMobile}
                            currentData={{
                                values: formattedConsVal?.period2,
                                compareValues1: currentData?.period1[selectedTab].delta_cons,
                                compareValues2: currentData?.period2[selectedTab].delta_cons,
                            }}
                            originData={currentData?.period2[selectedTab]}
                            isEmpty={currentData?.period2[selectedTab].declared === 0 && currentData?.period2[selectedTab].fact === 0}
                            getCalculateResult={getCalculateResult}
                            compareFunction={(a: any, b: any) => (a < b)}
                        />
                    }
                    {
                        selectedTab === tabs[1] &&
                        <DoughnutGraphPrice
                            graphId={TAB_1_GRAPH_2_ID}
                            isMobile={isMobile}
                            period={period2}
                            currentData={{
                                values: formattedPriceVal?.values2,
                                compareValues1: formattedPriceVal?.values1,
                                compareValues2: formattedPriceVal?.values2,
                                labels: formattedPriceVal?.labels2,
                                colors: formattedPriceVal.colors2
                            }}
                            isEmpty={currentData?.period2[selectedTab].values.length === 0}
                            getCalculateResultByArr={getCalculateResultByArr}
                            compareFunction={(a: any, b: any) => (a < b)}
                        />
                    }
                    {

                        selectedTab === tabs[2] &&
                        <DoughnutGraphTotal
                            graphId={TAB_2_GRAPH_2_ID}
                            isMobile={isMobile}
                            period={period2}
                            currentData={{
                                values: formattedTotalVal?.values2,
                                compareValues1: formattedTotalVal?.values1,
                                compareValues2: formattedTotalVal?.values2,
                                labels: formattedTotalVal?.labels2,
                                colors: formattedTotalVal?.colors2
                            }}
                            isEmpty={currentData?.period2[selectedTab].values.length === 0}
                            getCalculateResultByArr={getCalculateResultByArr}
                            compareFunction={(a: any, b: any) => (a < b)}
                        />
                    }
                </div>
            </div>
            {
                selectedTab === tabs[0] &&
                (!(currentData?.period1[selectedTab].declared === 0 && currentData?.period1[selectedTab].fact === 0) || !(currentData?.period2[selectedTab].declared === 0 && currentData?.period2[selectedTab].fact === 0))
                &&
                <div className='tab:w-[60%] mx-auto mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-center'>
                    {
                        isIterableArray(uniqueCons) &&
                        legendCons.map((item, index) => (
                            <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                setLegendCons(prev => prev.map(i => ({
                                    ...i,
                                    show: item.key === i.key ? !i.show : i.show
                                })))
                            }}>
                                <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? pieColors?.[item.key] : '#eee' }}></span>
                                <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                    {t(`analytics.${item.key}`)}
                                </Typography>
                            </div>
                        ))
                    }
                </div>
            }
            {
                selectedTab === tabs[1] &&
                (!(currentData?.period1[selectedTab].values.length === 0) || !(currentData?.period2[selectedTab].values.length === 0))
                &&
                <div className='tab:w-[60%] mx-auto mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-center'>
                    {
                        isIterableArray(uniquePrice) &&
                        legendPrice.map((item: any, index: any) => (
                            <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                setLegendPrice((prev: any) => prev.map((i: any) => ({
                                    ...i,
                                    show: item.key === i.key ? !i.show : i.show
                                })))
                            }}>
                                <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? doughnutColors?.[item.key] : '#eee' }}></span>
                                <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                    {t(`analytics.pie_${item.key}`)}
                                </Typography>
                            </div>
                        ))
                    }
                </div >
            }
            {
                selectedTab === tabs[2] &&
                (!(currentData?.period1[selectedTab].values.length === 0) || !(currentData?.period2[selectedTab].values.length === 0))
                &&
                <div className='tab:w-[60%] mx-auto mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-center'>
                    {
                        isIterableArray(uniquePrice) &&
                        legendTotal.map((item: any, index: any) => (
                            <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                setLegendTotal((prev: any) => prev.map((i: any) => ({
                                    ...i,
                                    show: item.key === i.key ? !i.show : i.show
                                })))
                            }}>
                                <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? doughnutColors?.[item.key] : '#eee' }}></span>
                                <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                    {t(`analytics.pie_${item.key}`)}
                                </Typography>
                            </div>
                        ))
                    }
                </div >
            }
        </>
    )
}

export default TabController